<template>
  <layout
    :footer="footer"
    :header="header"
    :country="country"
    :lang="lang"
    :about-us-url="aboutUsUrl"
    :hide-usps="isBrand"
  >
    <loading v-if="$fetchState.pending" />
    <div v-else class="flex-1 pt-8">
      <h1-title v-if="title" :title="title" />
      <info-box-list :items="formattedPaymentMethods" />
      <usps-block is-last />
    </div>
  </layout>
</template>
<script>
import { mapGetters } from 'vuex'
import createPageMixin from '~/mixins/page'
import { firstOfCollection } from '~/utils/collection'
import Layout from '~/components/layout/default'
import { Loading, H1Title, InfoBoxList } from '~/components/organisms'
export default {
  components: {
    H1Title,
    InfoBoxList,
    Layout,
    Loading,
  },
  mixins: [createPageMixin({ pageType: 'payment-methods' })],
  async fetch() {
    const { data: legalPageResponse } = await this.$contentful('legalPage')({
      slug: this.slug,
      locale: this.$store.getters['context/cmsLocale'],
    })

    const legal = firstOfCollection(legalPageResponse.legalPageCollection)

    if (!legal) return

    this.contentfulPageData = legal
    this.pageType = 'payment-methods'
  },
  computed: {
    ...mapGetters('contentful', ['sharedGlobalPaymentMethods']),
    title() {
      const h1Title = this.getSection('SectionH1Title')
      if (!h1Title) return ''
      return h1Title.title
    },
    formattedPaymentMethods() {
      return this.sharedGlobalPaymentMethods.map(paymentMethod => ({
        title: paymentMethod.name,
        image: paymentMethod.icon,
      }))
    },
  },
}
</script>
